module.exports = __webpack_public_path__ + "img/logo.abd85168.png";